import { useState } from "react";
import { toast } from "sonner";
import { LifeBuoy, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { inputCls } from "@/components/hub/Common";

const CATS = ["bug", "account", "clip", "live", "other"];

export const TicketForm = ({ onCreated }) => {
  const { t } = useI18n();
  const [f, setF] = useState({ subject: "", category: "bug", message: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/support/tickets", f);
      toast.success(t("sup.created"));
      setF({ subject: "", category: "bug", message: "" });
      onCreated(data.id);
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="cx-card cx-brackets rounded-2xl p-6 space-y-4" data-testid="ticket-form">
      <div className="flex items-center gap-2 font-display text-lg text-white"><LifeBuoy className="w-5 h-5 text-[#3ad7ff]" />{t("sup.new")}</div>
      <input data-testid="ticket-subject-input" className={inputCls} placeholder={t("sup.subject")} value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} required minLength={4} maxLength={140} />
      <div className="flex flex-wrap gap-2">
        {CATS.map((c) => (
          <button type="button" key={c} data-testid={`ticket-cat-${c}`} onClick={() => setF({ ...f, category: c })}
            className={`rounded-full px-3 py-1.5 text-xs border transition-colors ${f.category === c ? "border-[#3ad7ff] text-[#3ad7ff] bg-[#3ad7ff]/10" : "border-white/10 text-slate-400 hover:text-white"}`}>{t(`sup.cat_${c}`)}</button>
        ))}
      </div>
      <textarea data-testid="ticket-message-input" className={`${inputCls} min-h-[130px] resize-y`} placeholder={t("sup.message")} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} required minLength={10} maxLength={4000} />
      <button type="submit" disabled={busy} data-testid="ticket-submit-btn" className="cx-btn w-full rounded-full py-3 font-display font-semibold flex items-center justify-center gap-2">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />}{t("sup.send")}
      </button>
    </form>
  );
};
